import React, { Fragment } from 'react';
import styled, { css } from 'styled-components';
import { ThrobberDarkIcon } from '@parchment/icons';
import { white } from '../Colors/Colors';
import { small } from '../Styles/spacing';
export let LAYOUTS;

(function (LAYOUTS) {
  LAYOUTS["HORIZONTAL"] = "horizontal";
  LAYOUTS["VERTICAL"] = "vertical";
})(LAYOUTS || (LAYOUTS = {}));

export default function Loader(_ref) {
  let {
    loading = false,
    layout = LAYOUTS.HORIZONTAL,
    size = '1em',
    overlay = false,
    children,
    loadingMessage
  } = _ref;

  if (!loading) {
    return /*#__PURE__*/React.createElement(Fragment, null, children);
  }

  return /*#__PURE__*/React.createElement(Container, null, overlay && /*#__PURE__*/React.createElement(BlurContainer, {
    "aria-hidden": "true"
  }, children), /*#__PURE__*/React.createElement(LoaderContainer, {
    layout: layout,
    overlay: overlay
  }, /*#__PURE__*/React.createElement(StyledIcon, {
    contextType: "image",
    size: size,
    spin: true
  }), loadingMessage && /*#__PURE__*/React.createElement(LoadingMessage, null, loadingMessage)));
}
const Container = /*#__PURE__*/styled.div.withConfig({
  displayName: "Loader__Container",
  componentId: "sc-7tkrm5-0"
})(["position:relative;overflow:hidden;"]);
const BlurContainer = /*#__PURE__*/styled.div.withConfig({
  displayName: "Loader__BlurContainer",
  componentId: "sc-7tkrm5-1"
})(["filter:blur(2px);"]);
const InlineLoaderStyles = /*#__PURE__*/css(["position:relative;"]);
const OverlayLoaderStyles = /*#__PURE__*/css(["position:absolute;width:100%;height:100%;left:0;top:0;&:before{background:", ";opacity:0.9;}"], white);
const LoaderContainer = /*#__PURE__*/styled.div.withConfig({
  displayName: "Loader__LoaderContainer",
  componentId: "sc-7tkrm5-2"
})(["display:flex;flex-direction:", ";align-items:center;justify-content:center;", ";&:before{content:'';display:block;position:absolute;width:100%;height:100%;left:0;top:0;}"], _ref2 => {
  let {
    layout
  } = _ref2;
  return layout === 'horizontal' ? 'row' : 'column';
}, _ref3 => {
  let {
    overlay
  } = _ref3;
  return overlay && OverlayLoaderStyles || InlineLoaderStyles;
});
const LoadingMessage = /*#__PURE__*/styled.div.withConfig({
  displayName: "Loader__LoadingMessage",
  componentId: "sc-7tkrm5-3"
})(["position:relative;"]);
const StyledIcon = /*#__PURE__*/styled(ThrobberDarkIcon).withConfig({
  displayName: "Loader__StyledIcon",
  componentId: "sc-7tkrm5-4"
})(["margin:", ";"], small);